import { render, staticRenderFns } from "./matadd_tmpl.vue?vue&type=template&id=b48927e8&scoped=true"
import script from "./matadd_tmpl.vue?vue&type=script&lang=js"
export * from "./matadd_tmpl.vue?vue&type=script&lang=js"
import style0 from "./matadd_tmpl.vue?vue&type=style&index=0&id=b48927e8&prod&scoped=true&lang=less"
import style1 from "./matadd_tmpl.vue?vue&type=style&index=1&id=b48927e8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48927e8",
  null
  
)

export default component.exports